import { Component } from '@angular/core';
import { AuthService } from '../service/auth.service';

@Component({
  selector: 'app-trips',
  templateUrl: './trips.component.html',
  styleUrls: ['./trips.component.scss'],
  standalone: false,
})
export class TripsComponent {
  constructor(public authService: AuthService) {}
}
